<template>
  <div>
    <Card>
      <p slot="title">
        <Icon type="ios-stats"></Icon>
        统计分析
      </p>
      <div class="search-form">
        <Form ref="searchForm" :model="searchForm" inline :label-width="70">
          <FormItem label="时间范围">
            <DatePicker
              v-model="dateRange"
              type="daterange"
              format="yyyy-MM-dd"
              placement="bottom-end"
              placeholder="请选择时间范围"
              style="width: 220px"
              @on-change="handleDateChange"
            ></DatePicker>
          </FormItem>
          <FormItem label="供应商">
            <Select
              v-model="searchForm.compId"
              clearable
              filterable
              placeholder="全部"
              style="width: 200px"
            >
              <Option
                v-for="item in companyList"
                :value="item.id"
                :key="item.id"
              >{{ item.compName }}</Option>
            </Select>
          </FormItem>
          <FormItem label="物料">
            <Select
              v-model="searchForm.goodsName"
              clearable
              filterable
              placeholder="全部"
              style="width: 200px"
            >
              <Option
                v-for="item in goodsList"
                :value="item.goodsName"
                :key="item.id"
              >{{ item.goodsName }}</Option>
            </Select>
          </FormItem>
          <FormItem style="margin-left: 10px">
            <Button type="primary" @click="handleSearch">
              <Icon type="ios-search" />
              查询
            </Button>
            <Button @click="handleReset" style="margin-left: 10px">
              <Icon type="md-refresh" />
              重置
            </Button>
            <Button type="success" @click="handleExport" style="margin-left: 10px">
              <Icon type="md-download" />
              导出
            </Button>
          </FormItem>
        </Form>
      </div>
    </Card>

    <!-- 汇总卡片 -->
    <Row :gutter="16" style="margin-top: 16px">
      <Col span="6">
        <Card>
          <div class="summary-card">
            <div class="summary-icon" style="background: #2d8cf0;">
              <Icon type="md-car" size="32" color="#fff" />
            </div>
            <div class="summary-content">
              <div class="summary-value">{{ summary.totalCount || 0 }}</div>
              <div class="summary-label">总车次</div>
            </div>
          </div>
        </Card>
      </Col>
      <Col span="6">
        <Card>
          <div class="summary-card">
            <div class="summary-icon" style="background: #19be6b;">
              <Icon type="md-cube" size="32" color="#fff" />
            </div>
            <div class="summary-content">
              <div class="summary-value">{{ summary.totalNetWeight || 0 }}</div>
              <div class="summary-label">总净重(吨)</div>
            </div>
          </div>
        </Card>
      </Col>
      <Col span="6">
        <Card>
          <div class="summary-card">
            <div class="summary-icon" style="background: #ff9900;">
              <Icon type="md-analytics" size="32" color="#fff" />
            </div>
            <div class="summary-content">
              <div class="summary-value">{{ summary.avgNetWeight || 0 }}</div>
              <div class="summary-label">平均净重(吨)</div>
            </div>
          </div>
        </Card>
      </Col>
      <Col span="6">
        <Card>
          <div class="summary-card">
            <div class="summary-icon" style="background: #ed4014;">
              <Icon type="md-alert" size="32" color="#fff" />
            </div>
            <div class="summary-content">
              <div class="summary-value">{{ summary.abnormalCount || 0 }}</div>
              <div class="summary-label">异常数据</div>
            </div>
          </div>
        </Card>
      </Col>
    </Row>

    <!-- 详细统计卡片 -->
    <Row :gutter="16" style="margin-top: 16px">
      <Col span="8">
        <Card>
          <p slot="title">
            <Icon type="md-stats"></Icon>
            重量统计
          </p>
          <div class="detail-stats">
            <div class="stat-item">
              <span class="stat-label">总毛重：</span>
              <span class="stat-value">{{ summary.totalGrossWeight || 0 }} 吨</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">总皮重：</span>
              <span class="stat-value">{{ summary.totalTareWeight || 0 }} 吨</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">最大净重：</span>
              <span class="stat-value">{{ summary.maxNetWeight || 0 }} 吨</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">最小净重：</span>
              <span class="stat-value">{{ summary.minNetWeight || 0 }} 吨</span>
            </div>
          </div>
        </Card>
      </Col>
      <Col span="8">
        <Card>
          <p slot="title">
            <Icon type="md-business"></Icon>
            业务统计
          </p>
          <div class="detail-stats">
            <div class="stat-item">
              <span class="stat-label">供应商数量：</span>
              <span class="stat-value">{{ summary.companyCount || 0 }} 家</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">物料种类：</span>
              <span class="stat-value">{{ summary.goodsCount || 0 }} 种</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">车辆数量：</span>
              <span class="stat-value">{{ summary.vehicleCount || 0 }} 辆</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">正常数据：</span>
              <span class="stat-value" style="color: #19be6b;">{{ summary.normalCount || 0 }} 条</span>
            </div>
          </div>
        </Card>
      </Col>
      <Col span="8">
        <Card>
          <p slot="title">
            <Icon type="md-calculator"></Icon>
            平均值统计
          </p>
          <div class="detail-stats">
            <div class="stat-item">
              <span class="stat-label">日均车次：</span>
              <span class="stat-value">{{ calculateDailyAvg('count') }} 次</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">日均净重：</span>
              <span class="stat-value">{{ calculateDailyAvg('weight') }} 吨</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">单车平均：</span>
              <span class="stat-value">{{ summary.avgNetWeight || 0 }} 吨</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">异常率：</span>
              <span class="stat-value" style="color: #ed4014;">{{ calculateAbnormalRate() }}%</span>
            </div>
          </div>
        </Card>
      </Col>
    </Row>

    <!-- 图表区域 -->
    <Row :gutter="16" style="margin-top: 16px">
      <Col span="12">
        <Card>
          <p slot="title">物料运输占比</p>
          <div id="pieChart" style="width: 100%; height: 400px"></div>
        </Card>
      </Col>
      <Col span="12">
        <Card>
          <p slot="title">供应商排名 (Top 10)</p>
          <div id="barChart" style="width: 100%; height: 400px"></div>
        </Card>
      </Col>
    </Row>

    <Row :gutter="16" style="margin-top: 16px">
      <Col span="24">
        <Card>
          <p slot="title">每日趋势</p>
          <div id="lineChart" style="width: 100%; height: 400px"></div>
        </Card>
      </Col>
    </Row>

    <!-- 明细表格 -->
    <Card style="margin-top: 16px">
      <p slot="title">明细数据</p>
      <Table
        :loading="loading"
        border
        :columns="columns"
        :data="tableData"
        sortable="custom"
        stripe
      ></Table>
    </Card>
  </div>
</template>

<script>
import { getCompanyList, getGoodItemlist, getStatisticsData } from "@/api/index";
import * as echarts from "echarts";
import * as XLSX from "xlsx";

export default {
  name: "statistics",
  data() {
    return {
      loading: false,
      dateRange: [],
      searchForm: {
        startDate: "",
        endDate: "",
        compId: "",
        goodsName: ""
      },
      companyList: [],
      goodsList: [],
      summary: {},
      pieData: [],
      lineData: [],
      barData: [],
      tableData: [],
      columns: [
        {
          title: "日期",
          key: "date",
          width: 120,
          align: "center"
        },
        {
          title: "供应商",
          key: "compName",
          minWidth: 150
        },
        {
          title: "物料",
          key: "goodsName",
          minWidth: 120
        },
        {
          title: "车次",
          key: "count",
          width: 100,
          align: "center"
        },
        {
          title: "净重(吨)",
          key: "weight",
          width: 120,
          align: "center"
        }
      ],
      pieChart: null,
      barChart: null,
      lineChart: null
    };
  },
  mounted() {
    this.initDate();
    this.loadCompanyList();
    this.loadGoodsList();
    this.initCharts();
    this.loadData();
  },
  beforeDestroy() {
    if (this.pieChart) this.pieChart.dispose();
    if (this.barChart) this.barChart.dispose();
    if (this.lineChart) this.lineChart.dispose();
  },
  methods: {
    initDate() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.dateRange = [start, end];
      this.searchForm.startDate = this.formatDate(start);
      this.searchForm.endDate = this.formatDate(end);
    },
    formatDate(date) {
      const y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return `${y}-${m}-${d}`;
    },
    handleDateChange(dates) {
      if (dates && dates.length === 2) {
        this.searchForm.startDate = dates[0];
        this.searchForm.endDate = dates[1];
      } else {
        this.searchForm.startDate = "";
        this.searchForm.endDate = "";
      }
    },
    loadCompanyList() {
      getCompanyList({}).then(res => {
        if (res.success) {
          this.companyList = res.result.records || [];
        }
      });
    },
    loadGoodsList() {
      getGoodItemlist({}).then(res => {
        if (res.success) {
          this.goodsList = res.result.records || [];
        }
      });
    },
    initCharts() {
      this.pieChart = echarts.init(document.getElementById("pieChart"));
      this.barChart = echarts.init(document.getElementById("barChart"));
      this.lineChart = echarts.init(document.getElementById("lineChart"));
    },
    loadData() {
      this.loading = true;
      getStatisticsData(this.searchForm)
        .then(res => {
          if (res.success) {
            const data = res.result;
            this.summary = data.summary || {};
            this.pieData = data.pieData || [];
            this.lineData = data.lineData || [];
            this.barData = data.barData || [];

            this.renderPieChart();
            this.renderBarChart();
            this.renderLineChart();
            this.buildTableData();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    renderPieChart() {
      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "right"
        },
        series: [
          {
            type: "pie",
            radius: "60%",
            data: this.pieData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };
      this.pieChart.setOption(option);
    },
    renderBarChart() {
      if (!this.barData || this.barData.length === 0) {
        this.barChart.setOption({
          title: { text: "无数据", left: "center", top: "center" }
        });
        return;
      }
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" }
        },
        grid: { left: "3%", right: "4%", bottom: "3%", containLabel: true },
        xAxis: {
          type: "value"
        },
        yAxis: {
          type: "category",
          data: this.barData.map(item => item.name)
        },
        series: [
          {
            name: "净重(吨)",
            type: "bar",
            data: this.barData.map(item => item.value),
            itemStyle: { color: "#5470c6" }
          }
        ]
      };
      this.barChart.setOption(option);
    },
    renderLineChart() {
      const option = {
        tooltip: {
          trigger: "axis"
        },
        grid: { left: "3%", right: "4%", bottom: "3%", containLabel: true },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.lineData.map(item => item.date)
        },
        yAxis: {
          type: "value",
          name: "净重(吨)"
        },
        series: [
          {
            name: "净重",
            type: "line",
            smooth: true,
            data: this.lineData.map(item => item.value),
            areaStyle: {},
            itemStyle: { color: "#91cc75" }
          }
        ]
      };
      this.lineChart.setOption(option);
    },
    buildTableData() {
      // 根据图表数据构建明细表格（示例）
      this.tableData = this.lineData.map(item => ({
        date: item.date,
        compName: this.searchForm.compId
          ? this.companyList.find(c => c.id === this.searchForm.compId)?.compName || "-"
          : "全部",
        goodsName: this.searchForm.goodsName || "全部",
        count: "-",
        weight: item.value
      }));
    },
    handleSearch() {
      this.loadData();
    },
    handleReset() {
      this.initDate();
      this.dateRange = [new Date(this.searchForm.startDate), new Date(this.searchForm.endDate)];
      this.searchForm.compId = "";
      this.searchForm.goodsName = "";
      this.loadData();
    },
    calculateDailyAvg(type) {
      if (!this.searchForm.startDate || !this.searchForm.endDate) {
        return 0;
      }
      
      const start = new Date(this.searchForm.startDate);
      const end = new Date(this.searchForm.endDate);
      const days = Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;
      
      if (days <= 0) return 0;
      
      if (type === 'count') {
        return ((this.summary.totalCount || 0) / days).toFixed(1);
      } else if (type === 'weight') {
        return ((this.summary.totalNetWeight || 0) / days).toFixed(2);
      }
      return 0;
    },
    calculateAbnormalRate() {
      const total = this.summary.totalCount || 0;
      if (total === 0) return '0.00';
      const abnormal = this.summary.abnormalCount || 0;
      return ((abnormal / total) * 100).toFixed(2);
    },
    handleExport() {
      // 检查是否有数据
      if (!this.summary.totalCount || this.summary.totalCount === 0) {
        this.$Message.warning("暂无数据可导出");
        return;
      }

      try {
        // 准备导出数据
        const exportData = [];
        
        // 1. 添加标题
        exportData.push(['地磅称重统计报表']);
        exportData.push([]);
        
        // 2. 添加查询条件
        exportData.push(['查询条件']);
        exportData.push(['时间范围', `${this.searchForm.startDate} 至 ${this.searchForm.endDate}`]);
        if (this.searchForm.compId) {
          const company = this.companyList.find(c => c.id === this.searchForm.compId);
          exportData.push(['供应商', company ? company.compName : '全部']);
        } else {
          exportData.push(['供应商', '全部']);
        }
        if (this.searchForm.goodsName) {
          exportData.push(['物料', this.searchForm.goodsName]);
        } else {
          exportData.push(['物料', '全部']);
        }
        exportData.push([]);
        
        // 3. 添加汇总数据
        exportData.push(['统计汇总']);
        exportData.push(['总车次', this.summary.totalCount || 0]);
        exportData.push(['总净重(吨)', this.summary.totalNetWeight || 0]);
        exportData.push(['总毛重(吨)', this.summary.totalGrossWeight || 0]);
        exportData.push(['总皮重(吨)', this.summary.totalTareWeight || 0]);
        exportData.push(['平均净重(吨)', this.summary.avgNetWeight || 0]);
        exportData.push(['最大净重(吨)', this.summary.maxNetWeight || 0]);
        exportData.push(['最小净重(吨)', this.summary.minNetWeight || 0]);
        exportData.push([]);
        
        exportData.push(['业务统计']);
        exportData.push(['供应商数量', this.summary.companyCount || 0]);
        exportData.push(['物料种类', this.summary.goodsCount || 0]);
        exportData.push(['车辆数量', this.summary.vehicleCount || 0]);
        exportData.push(['正常数据', this.summary.normalCount || 0]);
        exportData.push(['异常数据', this.summary.abnormalCount || 0]);
        exportData.push(['异常率', this.calculateAbnormalRate() + '%']);
        exportData.push([]);
        
        exportData.push(['平均值统计']);
        exportData.push(['日均车次', this.calculateDailyAvg('count')]);
        exportData.push(['日均净重(吨)', this.calculateDailyAvg('weight')]);
        exportData.push([]);
        
        // 4. 添加物料运输统计
        if (this.pieData && this.pieData.length > 0) {
          exportData.push(['物料运输统计']);
          exportData.push(['物料名称', '车次', '占比']);
          const total = this.pieData.reduce((sum, item) => sum + item.value, 0);
          this.pieData.forEach(item => {
            const percent = total > 0 ? ((item.value / total) * 100).toFixed(2) + '%' : '0%';
            exportData.push([item.name, item.value, percent]);
          });
          exportData.push([]);
        }
        
        // 5. 添加每日趋势
        if (this.lineData && this.lineData.length > 0) {
          exportData.push(['每日趋势']);
          exportData.push(['日期', '净重(吨)']);
          this.lineData.forEach(item => {
            exportData.push([item.date, item.value]);
          });
          exportData.push([]);
        }
        
        // 6. 添加供应商排名
        if (this.barData && this.barData.length > 0) {
          exportData.push(['供应商排名 Top 10']);
          exportData.push(['排名', '供应商名称', '净重(吨)']);
          this.barData.forEach((item, index) => {
            exportData.push([index + 1, item.name, item.value]);
          });
        }
        
        // 创建工作表
        const ws = XLSX.utils.aoa_to_sheet(exportData);
        
        // 设置列宽
        ws['!cols'] = [
          { wch: 20 },  // A列
          { wch: 20 },  // B列
          { wch: 15 }   // C列
        ];
        
        // 创建工作簿
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '统计数据');
        
        // 生成文件名
        const fileName = `地磅统计_${this.searchForm.startDate}_${this.searchForm.endDate}.xlsx`;
        
        // 导出文件
        XLSX.writeFile(wb, fileName);
        
        this.$Message.success('导出成功');
      } catch (error) {
        console.error('导出失败:', error);
        this.$Message.error('导出失败，请重试');
      }
    }
  }
};
</script>

<style scoped lang="less">
.search-form {
  padding: 10px 0;
}

.summary-card {
  display: flex;
  align-items: center;
  padding: 20px;
  
  .summary-icon {
    width: 60px;
    height: 60px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
  }
  
  .summary-content {
    flex: 1;
    
    .summary-value {
      font-size: 28px;
      font-weight: bold;
      color: #333;
      margin-bottom: 5px;
    }
    
    .summary-label {
      font-size: 14px;
      color: #999;
    }
  }
}

.detail-stats {
  padding: 10px 0;
  
  .stat-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #f0f0f0;
    
    &:last-child {
      border-bottom: none;
    }
    
    .stat-label {
      font-size: 14px;
      color: #666;
    }
    
    .stat-value {
      font-size: 16px;
      font-weight: bold;
      color: #333;
    }
  }
}
</style>

